<div class="landing-page">

  <div class="landing-page-banner landing-page-banner-{{componentTypeName}}">
    <img width="100%" [src]="bannerImageAssetPath" alt=""
      class="landing-page-banner-image landing-page-banner-image-{{componentTypeName}} lazy-load loaded"
      typeof="foaf:Image" data-was-processed="true">
    <div class="landing-page-banner-title">{{titleText}}</div>
  </div>

  <mat-toolbar class="landing-page-toolbar mobile-hide" color="accent"
    *ngIf="menutItemChildrenFiltered && menutItemChildrenFiltered.length > 0">
    <mat-toolbar-row class="landing-toolbar-row" [@fadeInOut]="currentMenuParent">
      <div class="landing-button-row">

        <span *ngIf="hasOpenedSubMenu()" class="landing-header-span">
          <button mat-button class="landing-header-button landing-header-prev-menu-button" i18n="@actions.closeSubMenu"
            (click)="closeSubMenu()"> Back
            to {{previousMenuParent.link.title}}
            <mat-icon class="mat-icon-rtl-mirror">
              chevron_left
            </mat-icon>
          </button>
          <mat-divider [vertical]='true'></mat-divider>
        </span>

        <span *ngFor="let item of menutItemChildrenFiltered; index as i" class="landing-header-span">

          <app-link class="landing-header-app-link" [link]="item.link" *ngIf="isLeafMenuItem(item)">
            <mat-divider *ngIf="i != 0" [vertical]='true'></mat-divider>
            <button mat-button class="landing-header-button">{{item.link.title}}</button>
          </app-link>
          <span class="landing-header-span" *ngIf="isContainerMenuItem(item)">
            <mat-divider *ngIf="i != 0" [vertical]='true'></mat-divider>

            <button mat-button *ngIf="isLinkContainerMenuItem(item)" [routerLink]="item.link.link"
              class="landing-header-container-button">{{item.link.title}}</button>
            <button mat-icon-button *ngIf="isLinkContainerMenuItem(item)" [matMenuTriggerFor]="i"
              [attr.aria-label]="'toggle ' + item.link.title" (menuOpened)="menuOpened($event, item)"
              (menuClosed)="menuClosed($event, item)">
              <mat-icon class="mat-icon-rtl-mirror">
                {{isOpenMenu(item, i) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>

            <button mat-button *ngIf="isNoLinkContainerMenuItem(item)" [matMenuTriggerFor]="i"
              (menuOpened)="menuOpened($event, item)" (menuClosed)="menuClosed($event, item)"
              class="landing-header-container-button"
              [attr.aria-label]="'toggle ' + item.link.title">{{item.link.title}}
              <mat-icon class="mat-icon-rtl-mirror">
                {{isOpenMenu(item, i) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>

            <mat-menu #i="matMenu" class="landing-header-mat-menu" color="accent">
              <ng-container *ngFor="let child of getContainerChildren(item)">
                <app-link [link]="child.link">
                  <button *ngIf="isLeafMenuItem(child)" mat-menu-item color="accent"
                    class="landing-header-mat-menu-button">
                    {{child?.link?.title}}
                  </button>
                </app-link>


                <ng-container *ngIf="isContainerMenuItem(child)">

                  <app-link [link]="item.link">
                    <button mat-menu-item *ngIf="isLinkContainerMenuItem(child)"
                      class="landing-header-container-button child-menu-button">{{child.link.title}}</button>
                  </app-link>
                  <button mat-icon-button *ngIf="isLinkContainerMenuItem(child)"
                    [attr.aria-label]="'toggle ' + child.link.title">
                    <mat-icon class="mat-icon-rtl-mirror" (click)="openSubMenu(child)">
                      chevron_right
                    </mat-icon>
                  </button>

                  <button mat-menu-item *ngIf="isNoLinkContainerMenuItem(child)"
                    class="landing-header-container-button child-menu-button" (click)="openSubMenu(child)"
                    [attr.aria-label]="'toggle ' + child.link.title">{{child.link.title}}
                    <mat-icon class="mat-icon-rtl-mirror">
                      chevron_right
                    </mat-icon>
                  </button>
                </ng-container>
              </ng-container>
            </mat-menu>
          </span>
        </span>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>

  <ng-template app-landing-page-host></ng-template>

</div>
